/* Vidéos de fond posées par snippets/media-fond.liquid.
 *
 * Une vidéo ne joue que visible à l'écran : hors champ elle est en pause,
 * elle ne consomme ni batterie ni bande passante. Avec
 * `prefers-reduced-motion: reduce`, aucune ne démarre — l'image d'aperçu
 * reste. Le bouton pause, quand il existe, prime sur tout le reste : une
 * vidéo arrêtée par le visiteur ne repart pas au défilement.
 *
 * Module : chargé une seule fois même si plusieurs emplacements le
 * demandent.
 */

const reduit = window.matchMedia('(prefers-reduced-motion: reduce)');
const visibles = new WeakSet();

const jouable = (video) => visibles.has(video) && !reduit.matches && video.dataset.arretee !== 'oui';

function appliquer(video) {
  if (jouable(video)) {
    // play() est refusé si le navigateur bloque la lecture auto : l'aperçu
    // reste affiché, c'est le comportement voulu.
    video.play().catch(() => {});
  } else if (!video.paused) {
    video.pause();
  }
}

const observateur = new IntersectionObserver(
  (entrees) => {
    for (const { target, isIntersecting } of entrees) {
      if (isIntersecting) visibles.add(target);
      else visibles.delete(target);
      appliquer(target);
    }
  },
  { rootMargin: '100px 0px' },
);

function peindreBouton(bouton, video) {
  const arretee = video.dataset.arretee === 'oui';
  bouton.setAttribute('aria-label', arretee ? bouton.dataset.labelLecture : bouton.dataset.labelPause);
  bouton.classList.toggle('media-fond-pause--arretee', arretee);
}

function brancher(racine = document) {
  for (const video of racine.querySelectorAll('video[data-media-fond]')) {
    if (video.dataset.mediaFondPret) continue;
    video.dataset.mediaFondPret = 'oui';
    observateur.observe(video);

    // Le bouton suit sa vidéo dans le markup du snippet.
    const bouton = video.nextElementSibling?.matches('[data-media-fond-pause]')
      ? video.nextElementSibling
      : video.parentElement?.querySelector('[data-media-fond-pause]');
    if (!bouton) continue;

    // Sans animation, rien ne bouge : le bouton n'aurait rien à arrêter.
    bouton.hidden = reduit.matches;
    peindreBouton(bouton, video);
    bouton.addEventListener('click', () => {
      video.dataset.arretee = video.dataset.arretee === 'oui' ? 'non' : 'oui';
      peindreBouton(bouton, video);
      appliquer(video);
    });
  }
}

reduit.addEventListener('change', () => {
  for (const video of document.querySelectorAll('video[data-media-fond]')) appliquer(video);
  for (const bouton of document.querySelectorAll('[data-media-fond-pause]')) bouton.hidden = reduit.matches;
});

brancher();

// Éditeur de thème : une section ou un bloc modifié est re-rendu à neuf.
document.addEventListener('shopify:section:load', (e) => brancher(e.target));
document.addEventListener('shopify:block:select', (e) => brancher(e.target));
